module.exports = __webpack_public_path__ + "static/media/ftn-aktia-auth.2ab16c55.svg";